import {
  calculateCO2EmissionsData,
  CO2_TITLE_KEY_BY_LEVEL,
  DictionaryProvider,
  FootprintReceipt,
} from '@lmn/lmn-components';
import { useTranslation } from '@/app/components/translations/Translation';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { useIsMobile } from '@/app/components/hotel-detail/hooks/useMediaSSR';
import OpenXModal from '@/app/components/search/components/Modal/OpenXModal/index.tsx';
import BasicModalHeader from '@/app/components/search/components/Modal/LayoutElements/BasicModalHeader/index.tsx';
import { MODAL_SIZES } from '@/app/components/search/components/Modal/OpenXModal/types.ts';

type Co2ModalProps = {
  co2Footprint: CO2Footprint;
  isOpen: boolean;
  onClose: () => void;
  onOpenByBrowserHistory: () => void;
};

export default function Co2Modal({ co2Footprint, isOpen, onClose, onOpenByBrowserHistory }: Co2ModalProps) {
  const { localization } = usePageWrapperData();
  const { t, tripCardDictionary } = useTranslation();
  const isMobile = useIsMobile();

  const co2EmissionsData = calculateCO2EmissionsData(
    co2Footprint.co2kg,
    co2Footprint.averageCo2kg,
    localization.locale
  );
  const modalTitle = t(CO2_TITLE_KEY_BY_LEVEL[co2EmissionsData.level]);

  return (
    <DictionaryProvider labels={tripCardDictionary}>
      <OpenXModal
        isOpen={isOpen}
        onClose={onClose}
        onCloseByBrowserHistory={onClose}
        onOpenByBrowserHistory={onOpenByBrowserHistory}
        id="co2-modal"
        header={{
          sticky: true,
          element: <BasicModalHeader handleClose={onClose}>{modalTitle}</BasicModalHeader>,
        }}
        isMobile={!!isMobile}
        brand={localization.brand}
        size={MODAL_SIZES.S}
      >
        <FootprintReceipt data={co2EmissionsData} locale={localization.locale} />
      </OpenXModal>
    </DictionaryProvider>
  );
}
